import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BookOpen, ArrowUpRight, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function Topics() {
  const [topics, setTopics] = useState(null);

  useEffect(() => {
    api.get("/topics").then((r) => setTopics(r.data)).catch(() => {});
  }, []);

  if (!topics) return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12" data-testid="topics-page">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-2">Specification Explorer</p>
      <h1 className="text-4xl font-bold tracking-tighter">Topics</h1>
      <p className="mt-3 text-muted-foreground max-w-2xl">Every AQA A-Level Psychology topic, mapped to the official specification. Click a topic to drill into its subtopics and generate targeted practice questions.</p>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {topics.map((t, i) => (
          <motion.div key={t.topic} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.04 }}>
            <Link to={`/topics/${encodeURIComponent(t.topic)}`} data-testid={`topic-card-${t.topic.toLowerCase().replace(/\s+/g, "-")}`}
              className="group block card-lift rounded-3xl border border-border bg-card p-6 h-full">
              <div className="flex items-start justify-between mb-4">
                <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-indigo-500/20 to-purple-500/20 flex items-center justify-center">
                  <BookOpen className="h-4 w-4 text-primary" />
                </div>
                <ArrowUpRight className="h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors" />
              </div>
              <h3 className="font-semibold tracking-tight">{t.topic}</h3>
              <p className="mt-1 text-xs text-muted-foreground">{t.subtopic_count} specification areas</p>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
